import {RouteDefinition} from '../../../routes';
import {DatabaseScreen} from './DatabaseScreen';
import {Logs} from "./Logs";

export const DatabaseSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: '/settings/db',
        component: DatabaseScreen,
    },
    {
        routerLink: "/settings/db/logs",
        component: Logs
    }
];
